export default __webpack_public_path__ + "static/media/portfolio-51.18e61117.jpg";